import { VerificationScope, VerificationType } from '../types';

export const ALL_VERIFICATION_SCOPE = 'ALL' as const;

export const verificationScopeLabels: Record<VerificationScope, string> = {
  [ALL_VERIFICATION_SCOPE]: 'All verification data',
  [VerificationType.CAR_SHARING]: 'Car Sharing',
  [VerificationType.IDENTITY_VERIFICATION]: 'Identity Verification',
};

export function getVerificationScopeLabel(verificationScope: VerificationScope) {
  return verificationScopeLabels[verificationScope] ?? verificationScope;
}

export function toVerificationTypeHeader(verificationScope: VerificationScope): VerificationType | undefined {
  return verificationScope === ALL_VERIFICATION_SCOPE ? undefined : verificationScope;
}

export function getVerificationScopeOptions(includeAll = true): VerificationScope[] {
  const options: VerificationScope[] = [VerificationType.CAR_SHARING, VerificationType.IDENTITY_VERIFICATION];

  return includeAll ? [ALL_VERIFICATION_SCOPE, ...options] : options;
}
